import { render, staticRenderFns } from "./permisoList.vue?vue&type=template&id=5ab4302a"
import script from "./permisoList.vue?vue&type=script&lang=js"
export * from "./permisoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports